import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, filter, switchMap, tap } from 'rxjs';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { RoutingConfigurationUtilService } from '../../../../core/services/routing-configuration-util.service';
import { UserManager } from '../../../../core/services/user-manager';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { StatoFascicoloConfiguration } from '../../../configuration/stato-entita-configuration';
import { DescrittoriSezioneHash } from '../../../interface/descrittori-sezione-hash';
import { DescrittoreSezione } from '../../../models/descrittore-sezione';
import { ClassificazioneResponse } from "../../../models/dto/classificazione-response";
import { PraticaFullResponse } from "../../../models/dto/pratica-full-response";
import { FascicoloMap } from '../../../models/fascicolo-map';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { PraticaMap } from '../../../models/pratica-map';
import { PraticaFull } from '../../../models/pratica/pratica-full';
import { PraticaLight } from '../../../models/pratica/pratica-light';
import { ClassificazioneSezione } from "../../../models/sezioni/classificazione-sezione";
import { UtenteLoggato } from '../../../models/utente-loggato';
import { IntestazioneFascicoloService } from '../../../services/intestazione-fascicolo-service';
import { UtilityCommon } from '../../../utils/utility-common';
import { FascicoloSelectModal } from "../../option-component/aggiungiFascicolo/fascicolo-select-modal.component";
import { FascicoloDefinisciModal } from '../../option-component/definisciFascicolo/definisci-fascicolo-modal.component';
import { DepositoPctComponent } from '../../option-component/depositoPct/deposito-pct.component';
import { PctUtil } from '../../option-component/depositoPct/pct-util';
import { FascicoloGiudizialeAdapter } from '../../option-component/riunisciGiudizi/fascicolo-giudiziale-adapter';
import { RiunisciGiudiziComponent } from '../../option-component/riunisciGiudizi/riunisci-giudizi.component';
import { RiunioneRequest } from '../../pratica/pratiche-riunite/riunione-request';
import { InviaNotificaModalComponent } from '../../option-component/inviaNotifica/invia-notifica-modal.component';
import { Fascicolo } from 'src/app/common/models/fascicolo/fascicolo';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { UpdateMetadatiConservazioneComponent } from '../update-metadati-conservazione/update-metadati-conservazione.component';
import { MappingTipiEntitaFascicolo } from 'src/app/common/configuration/mapping-tipi-entita-fascicolo';

declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;
declare var getPraticaMapSync: any;

@Component({
  selector: 'ul [intestazione_fascicolo]',
  templateUrl: 'intestazione.component.html',
  styleUrls: ['./intestazione.component.css'],
  host: { '[class.pratiche]': '\'true\'', '[class.firstlevel]': '\'true\'' }
})
export class IntestazioneComponent implements OnInit {
  @Input() fascicolo: FascicoloFull;
  @Input() showOpzioni: boolean;
  @ViewChild('modalRiunisciGiudizi') riunisciGiudiziComponent: RiunisciGiudiziComponent;
  @ViewChild('fascicoloDefinisciModal') fascicoloDefinisciModal: FascicoloDefinisciModal;
  @ViewChild('inviaNotificaModal') inviaNotificaModal: InviaNotificaModalComponent;
  @ViewChild('depositoPct') depositoPct: DepositoPctComponent;
  @ViewChild('fascicoloSelectModal') fascicoloSelectModal: FascicoloSelectModal;
  sezione: ClassificazioneSezione;
  descrittori: DescrittoreSezione[];
  descrittoriFascicoloMap: DescrittoriSezioneHash;
  fascicoloMap: FascicoloMap;
  subscriptionFascicoloOperation: Subscription;
  archiviatoId: string = StatoFascicoloConfiguration.ARCHIVIATO;
  riunioneRequest: RiunioneRequest;
  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;
  subscriptionViewManagerIcon: Subscription;
  subscriptionViewManagerIntestazione: Subscription;

  constructor(
    private operationService: OperationsService,
    private viewManager: ViewManagerService,
    private helpers: HelpersService,
    private routingService: RoutingConfigurationUtilService,
    private intestazioneFascicoloService: IntestazioneFascicoloService,
    private userManager: UserManager,
    private modalNotifyService: ModalNotifyService,
    private router: Router, 
    private frontEndMapping: FrontEndMapping,
    private dialog: DialogService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.helpers.getDescrittori().subscribe(res => this.setDescrittori(res));

    if (this.showOpzioni == null) {
      this.showOpzioni = true;
    }
    this.subscriptionViewManagerIcon = this.viewManager.iconDocumentSubject$.subscribe(data => {
      this.fascicolo.intestazione.campi.isDocumentazione = data.viewDocumentIcon;
    });
    this.subscriptionViewManagerIntestazione = this.viewManager.intestazioneSubject$.subscribe(() => {
        this.operationService.checkIsDocumentazione(this.fascicolo.id).subscribe((isDocumentazione)=>
          this.fascicolo.intestazione.campi.isDocumentazione = isDocumentazione);
    });
    // this.operationService.checkVisibilityPratica(this.fascicolo.praticaBase.id).pipe(
    //   filter(res => res),
    //   switchMap(() => this.operationService.readPratica(this.getUrlReadPratica(this.fascicolo.praticaBase), this.fascicolo.idParent)),
    //   filter(res => res.pratica.idSezioneClassificazione),
    //   switchMap((res) => this.operationService.readSezione(this.getUrlReadSezione(this.fascicolo.praticaBase), res.pratica.idSezioneClassificazione)),
    //   tap(el => this.sezione = (<ClassificazioneResponse>el).sezione)
    // ).subscribe();
  }


  ngOnDestroy() {
    if (this.subscriptionViewManagerIcon) {
      this.subscriptionViewManagerIcon.unsubscribe();
    }
    if (this.subscriptionViewManagerIntestazione) {
      this.subscriptionViewManagerIntestazione.unsubscribe();
    }
  }


  getUrlReadSezione(pratica): string {
    return '/rs/ops/gp/' + pratica.tipoPratica.endpoint + '/prat/sez/classificazioni';
  }

  getUrlReadPratica(pratica): string {
    return '/rs/ops/gp/' + pratica.tipoPratica.endpoint + '/prat';
  }

  getUrlInsertPratica(pratica) {
    return ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + pratica.tipoPratica.endpoint + '/prat';
  }

  setDescrittori(descrittori: DescrittoreSezione[]) {
    this.descrittori = descrittori;
    this.descrittoriFascicoloMap = UtilityCommon.createHashMapDescrittoriFascicolo(descrittori);
  }

  onClickCopiaFascicolo(fascicolo: FascicoloLight, pratica: PraticaLight) {
    // let classificazione = new ClassificazioneSezione();
    // classificazione.classificazioni = this.sezione.classificazioni;
    // let request = {
    //   pratica: {
    //     tipoPratica: pratica.tipoPratica
    //   },
    //   classificazione
    // };
    // this.operationService.creatGenericPratica(this.getUrlInsertPratica(pratica), request).subscribe(response => this.responsePraticaCreate(response, fascicolo, pratica));
    this.copiaFascicolo(fascicolo, pratica);
  }

  copiaFascicolo(fascicolo: FascicoloLight, praticaOrigin: PraticaLight) {
    openModal('modalCopyFascicoloIntestazione');
    this.fascicoloSelectModal.inizializza(praticaOrigin.tipoPratica, praticaOrigin.id, fascicolo);
  }

  runMethodFascicoloOption(method: string, fascicolo: FascicoloFull, pratica: PraticaLight) {
    switch (method) {
      case 'definisciFascicolo':
        this.onClickDefinisciFascicolo();
        break;
      case 'rimuoviDefinizione':
        this.onClickDeleteDefinizioneFascicolo();
        break;
      case 'riunisciGiudizi':
        this.onClickRiunisciGiudizi();
        break;
      case 'rimuoviRiunioneGiudizio':
        this.onClickDeleteRiunioneGiudizio();
        break;
      case 'depositoPCT':
        this.onClickDepositoPct(fascicolo);
        break;
      case 'consultazionePCT':
        this.onClickConsultazionePct();
        break;
      case 'eliminaFascicolo':
        this.onClickDelete();
        break;
      case 'copiaFascicolo':
        this.onClickCopiaFascicolo(fascicolo, pratica);
        break;
      case 'inviaNotifica':
        this.onClickInviaNotifica(fascicolo,pratica);
        break;
      case 'metadatiConservazione':
        this.onClickOpenMetadataConservazione(fascicolo,pratica);
        break;
      case 'gestioneMetadatiFascicolo':
        this.onClickGestioneMetadati(fascicolo,pratica);
        break;
    }
  }

  onClickOpenMetadataConservazione(fascicolo,pratica) {
    const ref = this.dialog.open(UpdateMetadatiConservazioneComponent, {
      data: {
          style: { width: "80%", height: "100%"},
          title: "Aggiornamento metadati conservazione",
          fascicolo: fascicolo,
          pratica: pratica
        }
    });
    ref.afterClosed.subscribe(res => {
      if (res?.refresh) {
        this.viewManager.updateDocumentazione(res.documenti);
      }
    });
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloFull) {
    let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
    return categoriaMap;
  }

  tipoFascicoloString(idTipoFascicolo: string) {
    // let tipoFascicolo = FrontEndMapping.tipiFascicolo[idTipoFascicolo];
    let tipoFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(idTipoFascicolo).subscribe(res => {
      tipoFascicolo = res;
    });
    return tipoFascicolo;
  }

  onClickRiunisciGiudizi() {
    this.riunisciGiudiziComponent.inizializza(this.fascicolo, this.fascicolo.praticaBase);
    openModal('modalRiunisciGiudizi');
  }

  onClickDelete() {
    this.subscriptionFascicoloOperation = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.executeDeleteFascicolo(result));
    this.modalNotifyService.notifyDeleteFascicolo();
  }

  recallFascicolo(esito: boolean) {
    if (esito) {
      if (!this.fascicoloMap) {
        this.fascicoloMap = this.getFascicoloMap();
      }
      this.operationService.readFascicolo(this.fascicoloMap.pathView, this.fascicolo.id ).subscribe(response => this.intestazioneFascicoloService._notifyActionIntestazione.next(response.fascicolo));
    }
  }

  getFascicoloMap(): FascicoloMap {
      // let nomeFascicoloFE: string = FrontEndMapping.tipiFascicolo[this.fascicolo.tipoFascicolo.id];
      // let nomePraticaFE: string = FrontEndMapping.tipiPratica[this.fascicolo.praticaBase.tipoPratica.id];
      return <FascicoloMap> getFascicoloMapSync(this.fascicolo.praticaBase.tipoPratica.id, this.fascicolo.tipoFascicolo.id);
  }

  getRoutingPath(fascicolo, pratica): string {
    let path: string;
    path = this.routingService.checkStatoFascicoloAndGetRoutingPath(fascicolo, pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
    return path;
  }

  onClickDefinisciFascicolo() {
    this.fascicoloDefinisciModal.inizializza(this.fascicolo, this.fascicolo.praticaBase, false);
    openModal('modaldefinisciFascicolo');
  }

  onClickDeleteDefinizioneFascicolo() {
    this.subscriptionFascicoloOperation = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.deleteDefinizioneFascicolo(result));
    this.modalNotifyService.notifyDeleteDefinizioneFascicolo();
  }

  deleteDefinizioneFascicolo(result: boolean) {
    if (result) {
      if (!this.fascicoloMap) {
        this.fascicoloMap = this.getFascicoloMap();
      }
     this.operationService.eliminaDefinisciFascicolo(this.fascicoloMap.pathDefine, this.fascicolo.id).subscribe((response: any) =>{ 
        this.refreshFascicolo(response.returnCode === 'OK', this.fascicoloMap, this.fascicolo);
        this.fascicoloMap = null;
      });
    }
    if (this.subscriptionFascicoloOperation) {
      this.subscriptionFascicoloOperation.unsubscribe();
    }
  }

   refreshFascicolo(esito: boolean, fascicoloMap: FascicoloMap, fascicolo: Fascicolo) {
      if (esito) {
        this.operationService.readFascicolo(fascicoloMap.pathView, fascicolo.id).subscribe(response => this.intestazioneFascicoloService._notifyActionIntestazione.next(response.fascicolo));
      }
    }


  onClickDeleteRiunioneGiudizio() {
    this.subscriptionFascicoloOperation = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.deleteRiunioneGiudizio(result));
    this.modalNotifyService.notifyDeleteRiunioneGiudizio();
  }

  deleteRiunioneGiudizio(result: boolean) {
    if (result) {
      if (!this.fascicoloMap) {
        this.fascicoloMap = this.getFascicoloMap();
      }
      let praticaMap: PraticaMap = <PraticaMap> getPraticaMapSync(this.fascicolo.praticaBase.tipoPratica.id);
      this.operationService.readPratica(praticaMap.pathView, this.fascicolo.praticaBase.id ).subscribe(response => this.continueRimuoviRiunione(response.pratica));
    }
  }

  continueRimuoviRiunione(pratica: PraticaFull) {
    if (pratica) {
      this.riunioneRequest = new RiunioneRequest();
      let fascicoloRiunito = new FascicoloGiudizialeAdapter(<FascicoloFull>this.fascicolo);
      this.riunioneRequest.fascicoliDaRiunire.push(<FascicoloFull>fascicoloRiunito);
      this.operationService.eliminaRiunioneGiudizio(this.riunioneRequest).subscribe((response: any) => this.recallFascicolo(response.returnCode === 'OK'));
    }

    if (this.subscriptionFascicoloOperation) {
      this.subscriptionFascicoloOperation.unsubscribe();
    }
  }

  executeDeleteFascicolo(result: boolean) {
    if (result) {
      if (!this.fascicoloMap) {
        this.fascicoloMap = this.getFascicoloMap();
      }
      this.operationService.deleteFascicolo(this.fascicoloMap.pathDelete, this.fascicolo.id).subscribe(response => this.fascicoloDeleted(response));
    }
    if (this.subscriptionFascicoloOperation) {
      this.subscriptionFascicoloOperation.unsubscribe();
    }
  }

  fascicoloDeleted(response) {
    if (response.returnCode === 'OK') {
      this.viewManager._refreshAttivitaCompletare.next({param: response, timeOut: false});
      this.router.navigate(['']);
    }
  }

  onClickDepositoPct(fascicolo: FascicoloFull) {
    let urlIframe: string = null;
    let utenteLoggato: UtenteLoggato = this.userManager.getUser();
    let useActual = this.isUseActual(fascicolo);
    if (utenteLoggato) {
        urlIframe = useActual ?
          PctUtil.getUrlDepositoPctActual(this.fascicolo, this.fascicolo.praticaBase, utenteLoggato, true) 
          : PctUtil.getUrlDepositoPct(this.fascicolo, this.fascicolo.praticaBase, utenteLoggato);
        this.depositoPct.inizializza(urlIframe);
    }
  }
 
  isUseActual(fascicolo: FascicoloFull){
    let idTipoFascicolo = fascicolo?.tipoFascicolo?.id;
    let autorita = fascicolo?.autoritaGiudiziaria?.label?.toUpperCase();
 
    let isTipoFascicoloValido =
    [
        MappingTipiEntitaFascicolo.FASCICOLO_RICORSO,
        MappingTipiEntitaFascicolo.FASCICOLO_APPELLO
    ].includes(idTipoFascicolo);
 
    let isCassazione = autorita === 'CASSAZIONE';
 
    if ((isTipoFascicoloValido) && isCassazione) {
    return true;
    }
 
    return false;
  }

  onClickConsultazionePct() {
    let utenteLoggato: UtenteLoggato = this.userManager.getUser();
    let urlIframe = PctUtil.getUrlConsultazionePct(this.fascicolo, this.fascicolo.praticaBase, utenteLoggato);
    this.depositoPct.inizializza(urlIframe);
  }

  onClickInviaNotifica(fascicolo: FascicoloLight, pratica: PraticaLight) {
    this.inviaNotificaModal.inizializza(this.fascicolo, this.fascicolo.praticaBase, false);
    openModal('modalInviaNotifica');
  }

  onClickGestioneMetadati(fascicolo: FascicoloLight, pratica: PraticaLight) {
    const basePath = this.getRoutingPath(fascicolo, pratica);
    this.router.navigate([
      basePath,
      'gestione-metadati',
      fascicolo.id
    ]);
  }
}
